import React from "react";
import { observer } from "mobx-react-lite";
import type { CtrlPagination } from "src/components/tables/TableStore";
import { t } from "i18next";
import styles from "./EntityList.module.less";

type PropsEntityCount = {
  store: Pick<CtrlPagination, "totalItems">;
};

export const EntityCount: React.FC<PropsEntityCount> = observer(({ store }) => (
  <div className={styles.entityCount}>
    {t("Total instances count", { count: store.totalItems })}
  </div>
));
